import { FunctionComponent } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavbarItems } from '@/hooks';
import { useAuth } from '@/contexts';
import { Navbar } from '../Navbar';
import { AgoraLogo } from '../Navbar/components/AgoraLogo';
import { ResponsiveContainer } from '../ResponsiveContainer';
import { Row } from '../Row';
import { usePendingPathname } from '../Router/pendingNavigation';

export const Header: FunctionComponent = () => {
  const { session } = useAuth();
  const path = useLocation().pathname;
  // Con una navegación en curso el menú ya marca el destino (ver RailContainer).
  const pendingPath = usePendingPathname();
  const { mainItems, dropdownItems } = useNavbarItems(pendingPath ?? path);

  // Mientras llega la sesión: misma barra que el Navbar (alto, fondo y borde), así
  // el contenido no baja 16px cuando aparece el real.
  if (!session)
    return (
      <header
        className="sticky top-0 left-0 right-0 z-sticky h-16 border-b border-frost-hair lg:hidden"
        style={{ background: 'rgba(var(--f-card-rgb), 0.92)' }}
      >
        <ResponsiveContainer className="px-4">
          <Row align="center" className="w-full h-16">
            <AgoraLogo href="/" />
          </Row>
        </ResponsiveContainer>
      </header>
    );

  return (
    <Navbar onHome={session.is_staff ? '/agenda' : '/'} mainItems={mainItems} dropdownItems={dropdownItems} />
  );
};
